import { useLazyQuery, useQuery } from '@apollo/client'
import { useState, useEffect, useRef } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import PleaseWait from '../../components/PleaseWait'
import { GET_CARE_LOCATIONS } from '../../graphql/queries'
import { IGetCareLocationsInput, IGetCareLocationsOutput } from '../../graphql/types/queries/patient'
import { useIsVisible } from '../../hooks/useIsVisible'

interface ICareLocationsProps {
  id: string
}

export const CareLocations: React.FC<ICareLocationsProps> = ({ id }) => {
  const ref = useRef<any>();
  const isVisible = useIsVisible(ref);
  const [load, { data, loading, error }] = useLazyQuery<IGetCareLocationsOutput, IGetCareLocationsInput>(GET_CARE_LOCATIONS, {
    variables: {
      id
    }
  })

  useEffect(() => {
    if (!!isVisible) {
      load()
    }
  }, [isVisible])

  return (
    <Flex ref={ref} flexDirection={'column'} width='100%' padding={'20px'}>
      {!!loading ? (
        <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
          <PleaseWait
            text="Loading Patient's Care Locations" />
        </Flex>
      ) : (
        <>
          <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #FFABA0' }} paddingY={'12px'} mb={4}>
            <Flex>
              <Flex flexDirection={'column'} flex='1'>
                <Text fontWeight={600} fontSize='16px' mb={3}>Pharmacy</Text>
                {!data?.getProviderCareLocations?.pharmacy ? (
                  <Text color='#a2aab6' textAlign={'center'}>No Pharmacy on file</Text>
                ) : (
                  <>
                    <Text ml={2}>{data?.getProviderCareLocations?.pharmacy?.name}</Text>
                    <Text ml={2}>{data?.getProviderCareLocations?.pharmacy?.formattedAddress}</Text>
                    <Text ml={2}>{data?.getProviderCareLocations?.pharmacy?.phone}</Text>
                  </>)}
              </Flex>
              {/* <Flex>
          <Image src={data?.getProviderPatientQuickview.driverslicenseurl}/>
        </Flex> */}
            </Flex>
          </Flex>
          <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #B8D6F5' }} paddingY={'12px'} mb={4}>
            <Flex>
              <Flex flexDirection={'column'} flex='1'>
                <Text fontWeight={600} fontSize='16px' mb={3}>Lab Center</Text>
                {!data?.getProviderCareLocations?.labCenter ? (
                  <Text color='#a2aab6' textAlign={'center'}>No Lab Center on file</Text>
                ) : (
                  <>
                    <Text ml={2}>{data?.getProviderCareLocations?.labCenter?.name}</Text>
                    <Text ml={2}>{data?.getProviderCareLocations?.labCenter?.formattedAddress}</Text>
                    <Text ml={2}>{data?.getProviderCareLocations?.labCenter?.phone}</Text>
                  </>)}
              </Flex>
              {/* <Flex>
          <Image src={data?.getProviderPatientQuickview.driverslicenseurl}/>
        </Flex> */}
            </Flex>
          </Flex>
          <Flex flexDirection={'column'} style={{ width: '100%', flex: 'initial', paddingLeft: '20px', borderLeft: '3px solid #BCFFEB' }} paddingY={'12px'} mb={4}>
            <Flex>
              <Flex flexDirection={'column'} flex='1'>
                <Text fontWeight={600} fontSize='16px' mb={3}>PCP</Text>
                {!data?.getProviderCareLocations?.pcp ? (
                  <Text color='#a2aab6' textAlign={'center'}>No PCP on file</Text>
                ) : (
                  <>
                    <Text ml={2}>{data?.getProviderCareLocations?.pcp?.title} {data?.getProviderCareLocations?.pcp?.fullname}</Text>
                    <Text ml={2}>{data?.getProviderCareLocations?.pcp?.address}</Text>
                    {data?.getProviderCareLocations?.pcp?.address2 && (
                      <Text ml={2}>{data?.getProviderCareLocations?.pcp?.address2}</Text>
                    )}
                    <Text ml={2}>{data?.getProviderCareLocations?.pcp?.city}, {data?.getProviderCareLocations?.pcp?.state} {data?.getProviderCareLocations?.pcp?.zip}</Text>
                    <Text ml={2}>{data?.getProviderCareLocations?.pcp?.phone}</Text>
                  </>
                )}
              </Flex>
              {/* <Flex>
          <Image src={data?.getProviderPatientQuickview.driverslicenseurl}/>
        </Flex> */}
            </Flex>
          </Flex>
        </>)}
    </Flex>);
}